module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921104151_T.cd3c8313.jpg";